<template>
	<div class="prematch-nav">
		<button
			:class="{ 'prematch-nav__item': 1, active: selectedNav === '' }"
			@click="changeNav('')"
		>
			{{ $t("prebets.highlights") }}
		</button>
		<button
			:class="{ 'prematch-nav__item': 1, active: selectedNav === 'upcoming' }"
			@click="changeNav('upcoming')"
		>
			{{ $t("prebets.upcoming") }}
		</button>
		<router-link
			v-if="selectedSport"
			:class="{
				'prematch-nav__item': 1,
				active: $route.name === 'sport-countries',
			}"
			:to="{
				name: 'sport-countries',
				params: {
					sportName: $options.filters.seoText(selectedSport.sport_name),
				},
			}"
		>
			{{ $t("prebets.countries") }}
		</router-link>
		<button
			v-if="$store.getters.layout == 'Mobile' && env.showPreMatchNavItem"
			:class="{ 'prematch-nav__item': 1, active: selectedNav === 'jackpots' }"
			@click="openRoute('/jackpots/midweekjp')"
		>
			{{ $t("overlay-menu.jackpots") }}
		</button>
		<button
			v-if="showEsports && !env.showTopSoccerLeaguesFilter"
			:class="{
				'prematch-nav__item': 1,
				active: selectedNav === 'quick-e',
			}"
			@click="changeNav('quick-e')"
		>
			{{ $t("prebets.quick-e") }}
		</button>
		<router-link
			v-if="env.showTopSoccerLeaguesFilter && selectedSport.sport_name.toLowerCase() === 'soccer'"
			:class="{
				'prematch-nav__item': 1,
				active: $route.name === 'sport-leagues',
			}"
			:to="{
				name: 'sport-leagues',
				params: {
					sportName: $options.filters.seoText(selectedSport.sport_name),
				},
			}"
		>
			{{ $t("prebets.top-leagues") }}
		</router-link>
	</div>
</template>

<script>
export default {
	props: {
		selectedNav: {
			type: String,
			required: true,
			default: "",
		},
	},
	computed: {
		selectedSport() {
			return this.$store.getters.selectedSport;
		},

		showEsports() {
			return (
				this.env.esportMapping &&
				Boolean(
					this.env.esportMapping[
						this.selectedSport ? this.selectedSport.sport_id : null
					]
				)
			);
		},
	},
	methods: {
		changeNav(nav) {
			let vm = this;
			let params = {
				name: "sport",
				sportName: vm.$route.params.sportName,
			};
			if (vm.$route.name == "sport-competition") {
				params.name = "sport-competition";
				params.competitionName = vm.$route.params.competitionName;
			}
			vm.$router.push(params);
			this.analyticsTrack("general", "filterApplied", {
				filter_selection: nav === "" ? "Highlights" : nav,
			});
			vm.$emit("changeNav", nav);
		},
		openRoute(path) {
			let vm = this;
			vm.$router.push(path);
			vm.$emit("close");
			return;
		},
	},
};
</script>

<style lang="scss">
.prematch-nav {
	position: sticky;
	position: -webkit-sticky;
	top: 100px;
	z-index: 9;
	width: 100%;
	@media (min-width: 1023px) {
		top: 85px;
	}

	display: flex;
	flex-direction: row;
	background: var(--white);
	align-items: center;
	overflow-y: scroll;
	white-space: nowrap;

	&__item {
		background: none;
		border: none;
		margin: 0;
		padding: 15px 10px 15px 10px;
		font-size: var(--font-normal);
		color: var(--light-black);
		font-weight: var(--font-weight-normal);
		text-decoration: none;
		&.active {
			font-weight: var(--font-weight-bold);
			color: var(--black);
		}
	}
}
</style>
